// Renders strings where *segments* are highlighted.
export default function RichText({ text, highlightClass = 'text-white font-medium' }) {
  const parts = text.split(/(\*[^*]+\*)/g)
  return parts.map((part, i) =>
    part.startsWith('*') && part.endsWith('*') ? (
      <span key={i} className={highlightClass}>
        {part.slice(1, -1)}
      </span>
    ) : (
      <span key={i}>{part}</span>
    ),
  )
}
